var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"add_title colo0 font_weight500 font14 text_left"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"title_det"},[_vm._v(" "+_vm._s(_vm.titleDet))])])])}
var staticRenderFns = []

export { render, staticRenderFns }